import React, { CSSProperties } from 'react';
import { usePeers } from 'app/containers/rtc/PeersContext';
import PeerVideo from 'app/components/rtc/PeerVideo';
import Selfie from 'app/components/rtc/Selfie';

/**
 * The purpose of this component is to always keep at least one
 * instance of PeerVideo and Selfie active so that
 * corresponding <video> elements do not get
 * recreated when changing location from sidebar to
 * main content area and vice versa
 */

/**
 * These styles are important.
 * iOS optimizes invisible videos, pausing them internally
 * Safari continues to treat such videos as playing but
 * when reparented to a visible containers, the videos will
 * appear frozen.
 * This is true for both display: none and visibility: hidden.
 * Hence the need for such hack
 */
const wrapperStyle: CSSProperties = {
  position: 'absolute',
  top: '100%',
  opacity: 0,
  height: 0,
  width: 0,
  pointerEvents: 'none',
  overflow: 'hidden',
};

const RecycledCallVideosPlaceholder: React.FC<Record<string, unknown>> = () => {
  const peers = usePeers();
  const peerComponents = peers.map(peer => (
    <PeerVideo id={peer.id} key={peer.id} />
  )).toArray();

  return (
    <div style={wrapperStyle}>
      {peerComponents}
      <Selfie />
    </div>
  );
};

export default RecycledCallVideosPlaceholder;
